var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.084,
    height: 25.299,
    viewBox: "0 0 21.084 25.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162811",
    "data-name": "Group 162811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M4.216,115.62,0,119.836l4.216,4.216,4.216,4.217,4.216-4.217-4.216-4.216Z",
    transform: "translate(0 -102.971)",
    fill: "#00274c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M8.459,8.433h0v0l4.213-4.213L8.459,0,4.243,4.216.03,8.429l4.216,4.216Z",
    transform: "translate(-0.027)",
    fill: "#00274c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148436",
    "data-name": "Rectangle 148436",
    width: 5.964,
    height: 5.964,
    transform: "translate(12.65 12.65) rotate(-45)",
    fill: "#2bbbb5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logoSidebar.0edf7ae1b0f09183269590f99bb48732.svg";
export { ForwardRef as ReactComponent };